<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增
          </el-button>
          <!-- 删除 -->
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            @click.stop="handleDel(scope.row)"
            >批量删除</el-button>
          <!-- <el-button
            type="primary"
            size="small"
            plain
            @click.stop="downloadExcel()"
          >下载Excel
          </el-button> -->
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="toView(scope.row)"
            >查看</el-button
          >
          <!-- 删除 -->
         <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            @click.stop="handleDel(scope.row)"
            >删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="distributorIdForm"
        >
          <el-select
            v-model="distributor"
            placeholder="请选择经销商"
            filterable="filterable"
            required
            value-key="id"
          >
            <el-option
              v-for="distributor in distributors"
              :key="distributor.id"
              :label="distributor.shopName"
              :value="distributor"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="goodsForm"
        >
          <el-select
            v-model="goods"
            placeholder="请选择产品"
            filterable="filterable"
            required
            @change="findSku"
            value-key="id"
          >
            <el-option
              v-for="goods in goodsList"
              :key="goods.id"
              :label="goods.name"
              :value="goods"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="constituteForm"
        >
          <el-table
            :data="constitutes"
            border
          >
            <template v-for='(col,index) in tableData1'>
              <el-table-column
                sortable
                :show-overflow-tooltip="true"
                :prop="col.dataItem"
                :label="col.dataName"
                :key="col.dataItem"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    :disabled="col.disabled"
                    :name="col.dataName"
                    v-model="scope.row[index]"
                    :placeholder="col.placeholder"
                  ></el-input>
                </template>
              </el-table-column>
            </template>

          </el-table>

        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shipmentOption } from "@/const/salesCloud/shipmentManagementOption";
import {
  findShipmentList,
  findProductGoodsList,
  addShipment,
  deleteShipment,
  findShipmentById,
  updateShipment,
  send,
  findShipmentListExcel
} from "@/api/salesCloud/shipmentManagement";
import { findShop } from "@/api/salesCloud/productOrderDetailsMerchant";
import { findProductGoodsById } from "@/api/salesCloud/productGoods";
import { resolveUrlPath } from "@/util/util";

export default {
  name: "shipment",
  components: {},
  data() {
    return {
      tableOption: shipmentOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      downloadData: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      distributor: {},
      distributors: [],
      goods: {},
      goodsList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: []
    };
  },
  created() {
    this.handleList();
    findShop().then(res => {
      let data = JSON.parse(res.data);
      this.distributors = data;
    });
    findProductGoodsList().then(res => {
      let data = JSON.parse(res.data);
      this.goodsList = data;
      console.log(data, 99999);
    });
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findShipmentList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findShipmentList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      console.log(params);
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startTime_endTime &&
        undefined != params.startTime_endTime &&
        "" != params.startTime_endTime
      ) {
        params.startTime = params.startTime_endTime[0];
        params.endTime = params.startTime_endTime[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      this.downloadData = params;
      findShipmentList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findShipmentList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      let obj = {
        label: "新增产品出货",
        value: "shipmentManagement/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
      // this.clean();
      // this.$refs.crud.rowAdd();
    },
    /**
     * 
     * @param {id} row 
     * @dscription 查看详情
     */
    toView(row) {
      let obj = {
        label: "查看产品出货",
        value: "shipmentManagement/view"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: {
          id: row.id
        }
      });
    },
    handleEdit(row, index) {
      findShipmentById(row.id).then(res => {
        let data = JSON.parse(res.data);
        this.goods = { id: data.productId };
        console.log(data, 99999);

        this.distributor = { id: data.dealerId };
        let shipmentSkus = data.shipmentSkus;
        this.constitutes = [];
        findProductGoodsById(this.goods.id).then(res => {
          let data = JSON.parse(res.data);
          this.sku = { id: data.skuId };
          this.formatConstitute(data.skuConstitute);
          this.dataSku1 = data.dataSku;
          for (let i = 0; i < data.dataSku.length; i++) {
            let mapObj = new Map();
            let dataSku = data.dataSku[i];
            let map = this.objToStrMap(dataSku);
            let arrayVal = map.get("skuValue").split(":");
            let tableData2 = this.tableData1;

            for (let j = 0; j < tableData2.length; j++) {
              let obj1 = tableData2[j];
              if (typeof obj1.id != "undefined") {
                mapObj.set(obj1.flag, arrayVal[obj1.flag]);
              } else {
                mapObj.set(obj1.flag, map.get(obj1.dataItem));
              }
            }
            mapObj.set("skuId", dataSku.id);
            //console.log(this.strMapToObj(mapObj),988)
            this.constitutes.push(this.strMapToObj(mapObj));
          }
          let constitutes = [];
          console.log(this.constitutes, 6666);
          for (let i = 0; i < this.constitutes.length; i++) {
            let obj = this.constitutes[i];
            for (let j = 0; j < shipmentSkus.length; j++) {
              let obj1 = shipmentSkus[j];

              if (obj.skuId == obj1.skuId) {
                let map = this.objToStrMap(obj);
                let num = this.dataSku1.length;
                map.set(num + "", obj1.price);
                map.set(num + 1 + "", obj1.number);
                map.set("id", obj1.id);
                console.log(map, 8888);
                constitutes.push(this.strMapToObj(map));
              }
            }
          }
          this.constitutes = constitutes;
        });
      });
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findShipmentList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(this.constitutes, 7777);
      let data = {};
      let joinsProductShipmentDetails = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let map = this.objToStrMap(obj);
        console.log(map, 999);
        let details = {};
        let num = 0;
        console.log(this.dataSku1, 66666);
        for (let j = 0; j < this.dataSku1.length; j++) {
          if (j == 0) {
            let sku = this.dataSku1[j];
            let skuArray = sku.skuValue.split(":");
            num = skuArray.length;
            break;
          }
        }
        let price = map.get(num + "");
        let number = map.get(num + 1 + "");
        details.price = price;
        details.number = number;
        details.skuId = map.get("skuId");
        joinsProductShipmentDetails.push(details);
      }
      data.joinsProductShipmentDetails = joinsProductShipmentDetails;
      data.dealerId = this.distributor.id;
      data.productId = this.goods.id;
      console.log(data, 99909);
      addShipment(data)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            done();
            this.$refs.crud.rowAdd();
            return;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        console.log(ids);
      } else {
        if (this.ids) {
          console.log(this.ids);
        } else {
          this.$message({
            showClose: true,
            message: "未选择任何数据",
            type: "error"
          });
          return
        }
      }
      this.$confirm(`是否确认删除?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
      })
          .then(() => {
              /* let ids = new Array();
              for (let row of this.$refs.crud.tableSelect) {
                  ids.push(row.id)
              } */
              console.log(ids, 9999);
              deleteShipment(ids).then(response => {
                  if (response.code == '200') {
                      this.$message({
                          showClose: true,
                          message: "删除成功",
                          type: "success"
                      });
                      this.handleList();
                  } else {
                      this.$message({
                          showClose: true,
                          message: response.message,
                          type: "error"
                      })
                  }
      
              }).catch(error => {
                  this.loading = false
                  this.$message({
                      showClose: true,
                      message: error,
                      type: "error"
                  })
              })
          })
          .catch(() => {
          });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(this.constitutes, 7777);
      let data = {};
      let joinsProductShipmentDetails = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let map = this.objToStrMap(obj);
        console.log(map, 999);
        let details = {};
        let num = this.dataSku1.length;

        let price = map.get(num + "");
        let number = map.get(num + 1 + "");
        details.price = price;
        details.number = number;
        details.skuId = map.get("skuId");
        details.id = map.get("id");
        joinsProductShipmentDetails.push(details);
      }
      data.joinsProductShipmentDetails = joinsProductShipmentDetails;
      data.dealerId = this.distributor.id;
      data.productId = this.goods.id;
      data.id = row.id;
      console.log(data, 99909);
      updateShipment(data)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            done();
            this.$refs.crud.rowAdd();
            return;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    findSku() {
      this.constitutes = [];
      findProductGoodsById(this.goods.id).then(res => {
        let data = JSON.parse(res.data);
        this.sku = { id: data.skuId };
        this.formatConstitute(data.skuConstitute);
        console.log(this.formatConstitute(data.skuConstitute));
        this.dataSku1 = data.dataSku;
        for (let i = 0; i < data.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = data.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.tableData1;

          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];
            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }
          mapObj.set("skuId", dataSku.id);
          console.log(this.strMapToObj(mapObj), 988);
          this.constitutes.push(this.strMapToObj(mapObj));
        }
      });
    },
    formatConstitute(data) {
      let flag = 0;
      this.tableData1 = new Array(data.length + 2);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        console.log(data[i]);
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        obj.disabled = true;
        this.tableData1[flag] = obj;
        //this.tableData1.push(obj)
        flag++;
      }
      this.tableData1[flag] = {
        dataItem: "unitPrice",
        dataName: "产品单价",
        placeholder: "产品单价",
        flag: flag,
        disabled: false
      };
      this.tableData1[flag + 1] = {
        dataItem: "number",
        dataName: "出货量",
        placeholder: "出货量",
        flag: flag + 1,
        disabled: false
      };

      console.dir(this.tableData1, 43434);
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    clean() {
      this.distributor = {};
      this.goods = {};
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
    },
    send(id) {
      this.$confirm(`是否确认出货?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          send(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "出货成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    downloadExcel() {
      let params = this.downloadData;
      findShipmentListExcel(params).then(res => {
        if (res.code == "200") {
          window.open(res.data);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
